export default __webpack_public_path__ + "static/media/graduation-cap.d01a1b1a.png";